/*
Copyright (c) 2022 COUNTRYSIDE STOVE & CHIMNEY, INC. - ALL RIGHTS RESERVED

UNAUTHORIZED COPYING, MODIFICATION, OR DISTRIBUTION OF THIS SOFTWARE AND ASSOCIATED DOCUMENTATION FILES ("THE SOFTWARE"),
IN ANY MEDIUM IS STRICTLY PROHIBITED
PROPRIETARY AND CONFIDENTIAL
WRITTEN BY BRANDON SULLIVAN <info@empiredistributing.net>, March 2022
*/

import 'react-native-gesture-handler';
import React, {useEffect, useRef, useState} from 'react'
import {analytics, Crashlytics, firestore, getAuth, onAuthStateChanged} from './src/firebase/config'
import {TutorialDeviceStorage} from './src/utilities';
import NetInfo from '@react-native-community/netinfo';
//import * as BackgroundFetch from 'expo-background-fetch';
import {NavigationContainer} from '@react-navigation/native'
import {createStackNavigator} from '@react-navigation/stack'
import {ActivityIndicator, Dimensions, Image, Platform, Pressable, SafeAreaView, Text} from 'react-native'
import {Icon} from 'react-native-elements'
import {
    AboutScreen,
    ActivityFeedScreen,
    AllCatalogsScreen,
    CatalogScreen,
    CatalogUpdateScreen,
    ForgotPasswordScreen,
    LegalScreen,
    LoginScreen,
    NotificationsScreen,
    PreferencesScreen,
    RegistrationScreen,
    SettingsScreen,
    TutorialScreen,
    ViewCatalogScreen,
    ViewScreen
} from './src/screens';
import {decode, encode} from 'base-64'
import {StatusBar} from 'expo-status-bar';
import * as Linking from 'expo-linking';
import {BASE_URL, BASE_URL_REDIRECT, FCM_WEB_MESSAGING_KEY} from "@env";

if (!global.btoa) {  global.btoa = encode }
if (!global.atob) { global.atob = decode }
const Stack = createStackNavigator();
const usersRef = firestore.collection('users');
const accountsRef = firestore.collection('Accounts');
const entireScreenWidth = Dimensions.get('window').width;
const entireScreenHeight = Dimensions.get('window').height;
let userGlobal = null;

/*
//Handle notifications in application foreground.
Notifications.setNotificationHandler({
  handleNotification: async () => ({
    shouldShowAlert: true,
    shouldPlaySound: true,
    shouldSetBadge: true,
  }),
});

//Handle notifications in the application background.
const BACKGROUND_NOTIFICATION_TASK = 'BACKGROUND-NOTIFICATION-TASK';
const BACKGROUND_FETCH_TASK = 'background-fetch';

TaskManager.defineTask(
BACKGROUND_NOTIFICATION_TASK,
({ data, error, executionInfo }) => {
Notifications.getBadgeCountAsync().then(result => {Notifications.setBadgeCountAsync(result + 1)})
.catch((err) => {});
}
)
//Notifications.registerTaskAsync(BACKGROUND_NOTIFICATION_TASK);
//Background Fetch Task
TaskManager.defineTask(BACKGROUND_FETCH_TASK, async () => {
const now = Date.now();
function onResult(document) {
const unread = document.data().unreadCounter.totalUnreadCount;
Notifications.setBadgeCountAsync(unread).then((result) => {
}).catch((error) => {
console.error("Error getting unread notifications");
});
};
function onError(error) {
console.error("Error getting unread notifications");
};
if (userGlobal && Platform.OS != 'web') {
usersRef.doc(userGlobal).onSnapshot(onResult, onError);}
return BackgroundFetch.Result.NewData;
});
*/



export default function App() {
async function isTutorialEnabled() {
    return await TutorialDeviceStorage.getShouldShowTutorial();
}
  const subscriptions = [];
  const auth = getAuth();
  const [tutorialEnabled, setTutorialEnabled] = useState(null);
  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState(null);
  const [account, setAccount] = useState(null);
  const [fcmToken, setFCMToken] = useState("");
  const [networkStatus, setNetworkStatus] = useState(false);
    useRef();
    useRef();
    const routeNameRef = useRef();
  const navigationRef = useRef();

//Checks to see if onboarding tutorial should run...
const runTutorialCheck = async () => {
const status = await isTutorialEnabled();
if (Platform.OS === 'web') {
setTutorialEnabled(false);
}
else {
setTutorialEnabled(status);
}
}

//Network Status
useEffect(() => {
const unsubscribe = NetInfo.addEventListener(status => {
setNetworkStatus(status);
})
subscriptions.push(unsubscribe);
},[])



/*//Displays push notifications in foreground via notifee
const displayNotification = async (message) => {
console.log(`Inbound Notifee Notification: ${JSON.stringify(message)}`);
const channelId = await notifee.createChannel({
id: 'default',
name: 'Default Channel'
}).catch((e) => console.error(`Error creating notifee channel ${e}`));

await notifee.displayNotification({
title: message.notification.title,
body: message.notification.body,
android: {
channelId: channelId,
//importance: AndroidImportance.HIGH,
},
ios: {
foregroundPresentationOptions: {
alert: true,
badge: true,
sound: true,
},
},
}).catch((e) => {
console.error(`Error displaying notifee push notification: ${JSON.stringify(e)}`);
Crashlytics.recordError(e);
});
};*/


/*
//Blocks In-App Messaging
async function blockInAppMessaging() {
await inAppMessaging().setMessagesDisplaySupressed(true);
};

//Allows In-App Messaging
async function allowInappMessaging() {
await inAppMessaging().setMessagesDisplaySuppressed(false);
};

*/

/*
//OTA Updates
//This is configured to run each time the app is foregrounded.
useEffect(() => {
const callback = () => {
if (AppState.currentState === 'active') {
OTAUpdates.checkForUpdates(true);
}
}
AppState.addEventListener('change', callback)
},[AppState.currentState]);
*/

/*
//Push Notification Handler for Foreground
const pushNotifications = () => {
console.log(`Registering for push notifications in foreground...`);
let i = 0;
const foregroundPushNotifications = Messaging.onMessage(async remoteMessage => {
console.log(`New Push Notification received in the foreground on ${Platform.OS} | I: ${i} |${JSON.stringify(remoteMessage)}`);
//Alert.alert('A new FCM message arrived!', JSON.stringify(remoteMessage));
displayNotification(remoteMessage);
i++;
});
return foregroundPushNotifications;
}
*/

useEffect(() => {
let authListenerActive = false;
//const authListener = auth().onAuthStateChanged(User => {
const authListener = onAuthStateChanged(auth, User => {
if (User) {
//Signed-In
if (!authListenerActive) {
authListenerActive = true;
console.log(`User: ${User.uid}`);
runTutorialCheck();
subscribeUser(User.uid).then((res) => {subscribeAccount(res)}).catch((e) => {console.error(`Error subscribing account from auth listener: ${e}`)});
//requestPermission();
//getMessagingToken();
//pushNotifications();
}
}
else {
//Signed-Out
authListenerActive = false;
setUser(null);
userGlobal = null;
setAccount(null);
setLoading(false);
subscriptions.forEach((subscription) => subscription());
}
});
return () => authListener;
},[]);

/*

//Subscribes to user profile
  const subscribeUser = () => {
  const currentUser = auth.currentUser.uid;
  console.log(`Subscribing User... ${currentUser}`);
  function onResult(document) {
  const userData = document.data();
  userGlobal = currentUser;
  setUser(userData);
  subscribeAccount(userData.accountID);
  }
  function onError(e) {
  console.error(`Error subscribing user: ${e}`);
  }
  const subscription = usersRef.doc(currentUser).onSnapshot(onResult, onError);
  subscriptions.push(subscription);
  }
*/

    const subscribeUser = async (uid) => {
        return new Promise(async (res, rej) => {
            console.log(`SUBSCRIBING USER | SUBSCRIBING USER | SUBSCRIBING USER | SUBSCRIBING USER: ${uid}`);
            function onResult(document) {
                const userData = document.data();
                setUser(userData);
                res(userData.accountID);
            }
            function onError(e) {
                console.error(`Error subscribing user: ${e}`);
                Crashlytics.recordError(e);
                rej(e);
            }
            const subscription = usersRef.doc(uid).onSnapshot(onResult, onError);
            return () => subscription();
        })
    }

/*  //Subscribes to account for acccount changes
  const subscribeAccount = (accountID) => {
  console.log(`Subscribing Account: ${accountID}`);
  function onResult(document) {
    const acData = document.data().account_data;
    const accountData = {
    accountName: acData.customername,
    product_lines: document.data().product_lines,
    pricelevel: acData.pricelevel,
    salesRep: {
    sr_name: acData.sr_name,
    sr_email: acData.sr_emailaddress,
    sr_phone: acData.sr_telephoneno
    }
    }
    accountData.id = document.id;
    console.log(`Account Data: ${JSON.stringify(acData)}`);
      if (acData) {
      //console.log(`Account Data: ${JSON.stringify(acData)}`);
      //THIS IS TEMPORARY AND WILL NEED TO BE CHANGED LATER FOR FCM TOPICS

        /!*

      if (messagingSubscriptionEnabled) {
        accountData.product_lines.forEach((pl) => {
        if (messagingSubscriptionAction === 'subscribe') {
        Messaging.subscribeToTopic(pl).then(() => {console.log("Subscribed To Topic: ", pl)})
        .catch((err) => {
        console.error("Error subscribing user to topic: ", err);
        Crashlytics().recordError(err);
        });
        }
        else {
        Messaging.unsubscribeToTopic(pl).then(() => {console.log("Unsubscribed from Topic: ", pl)})
        .catch((err) => {
        console.error("Error unsubscribing user from topic: ", err);
        Crashlytics().recordError(err);
        });
        }
        })
      }
      *!/




      setAccount(accountData);
      if (loading) {setLoading(false)}
      }
  }
  function onError(e) {
  console.log(`Error subscribing account: ${e}`);
  Crashlytics.recordError(e);
  }
  const subscription = accountsRef.doc(accountID).onSnapshot(onResult, onError);
  subscriptions.push(subscription);
  }*/
    //Subscribes to account for acccount changes
    const subscribeAccount = (accountID) => {
        function onResult(document) {
            const acData = document.data().account_data;
            const accountData = {
                accountName: acData.customername,
                product_lines: document.data().product_lines,
                pricelevel: acData.pricelevel,
                salesRep: {
                    sr_name: acData.sr_name,
                    sr_email: acData.sr_emailaddress,
                    sr_phone: acData.sr_telephoneno
                }
            }
            accountData.id = document.id;
            console.log(`Account Data: ${JSON.stringify(acData)}`);
            if (acData) {
                setAccount(accountData);
                if (loading) {setLoading(false)}
            }
        }
        function onError(e) {
            console.log(`Error subscribing account: ${e}`);
            Crashlytics.recordError(e);
        }
        const subscription = accountsRef.doc(accountID).onSnapshot(onResult, onError);
        return () => subscription();
    }


const loadingScreen = () => {return (
<SafeAreaView style={{flex: 1, backgroundColor: 'black', justifyContent: 'center'}}>
      <Image
      style={{flex: 1, resizeMode: 'contain', width: entireScreenWidth, alignSelf: 'center', marginTop: entireScreenHeight / 18}}
      source={require('./assets/infernoIcon.png')}
     />
     <ActivityIndicator size="large" color="white"/>
     <Text style={{flex: 1, color: 'white', textAlign: 'center', fontWeight: 'bold', fontSize: 20, paddingTop: 10}}>Loading...</Text>
     </SafeAreaView>
)
}

if (loading) {
return loadingScreen()
}

   const linking = {
   prefixes: [Linking.createURL('/'), BASE_URL, BASE_URL_REDIRECT, "empiredistributing"]
   }
  return (
    <NavigationContainer
      linking={linking}
      fallback={loadingScreen()}
      ref={navigationRef}
      onReady={() => {
        routeNameRef.current = navigationRef.current.getCurrentRoute().name;
      }}
      onStateChange={async () => {
        const previousRouteName = routeNameRef.current;
        const currentRouteName = navigationRef.current.getCurrentRoute().name;

        if (previousRouteName !== currentRouteName) {
          await analytics.logEvent({
            screen_name: currentRouteName,
            screen_class: currentRouteName,
          });
        }
        routeNameRef.current = currentRouteName;
      }}
    >
<StatusBar style="light" />
<Stack.Navigator
screenOptions={() => ({
gestureDirection: 'horizontal',
cardStyle: {flex: 1},
headerTintColor: 'white',
headerTitleAlign: 'center',
headerStyle: {
backgroundColor: 'black'
},
})}
>
 {user && account? (
  <>
       <Stack.Screen name="Catalogs"
        options={({ navigation }) => ({
        headerTitle: "Catalogs",
        presentation: 'transparentModal',
        headerLeft: () => (
        <Pressable
        style={{ position: 'absolute', left: 15 }}
        onPress={() => {
        navigation.navigate('Settings')}}>
        <Icon
         name='cogs'
         type='material-community'
         color='lightgray'
         size={30}
         />
         </Pressable>
        ),
        })}
        >
        {props => <AllCatalogsScreen {...props}
         extraData={{user: user, productLines: account.product_lines}} />}
        </Stack.Screen>

         <Stack.Screen
          name="Catalog"
                   options={{
                   title: '',
                   presentation: 'transparentModal',
                    }}
          >
          {props => <CatalogScreen {...props} extraData={{user: user, productLines: account.product_lines, networkStatus: networkStatus}} />}
          </Stack.Screen>
           <Stack.Screen
            name="CatalogUpdate"
            options={{
                      title: '',
                      }}>
                      {props => <CatalogUpdateScreen {...props} extraData={{user: user}} />}
                    </Stack.Screen>

                  <Stack.Screen
                   name="Activity Feed"
                   options={{
                         title: 'Activity Feed',
                         presentation: 'transparentModal',
                         }}
                         >
                         {props => <ActivityFeedScreen {...props} extraData={{user: user, account: account, networkStatus: networkStatus}} />}
                         </Stack.Screen>
                                 <Stack.Screen
                                      name="Settings"
                                      options={({ navigation }) => ({
                                      title: 'Settings',
                                      presentation: 'transparentModal',
                                      headerRight: () => (
                                      <Pressable
                                       style={{ position: 'absolute', right: 15 }}
                                       onPress={() => {
                                       navigation.navigate('About')}}>
                                      <Icon
                                       name='help-outline'
                                       type='MaterialCommunityIcons'
                                       color='lightgray'
                                       size={30}
                                       />
                                      </Pressable>
                                      ),
                                      })}
                                       >
                                       {props => <SettingsScreen {...props} extraData={{user: user, account: account, fcmToken: fcmToken}} />}
                         </Stack.Screen>
                         <Stack.Screen
                         name="Preferences"
                         options={({ navigation }) => ({
                         title: 'Settings',
                         headerRight: () => (
                         <Pressable
                         style={{ position: 'absolute', right: 15 }}
                         onPress={() => {
                         navigation.navigate('About')}}>
                         <Icon
                         name='help-outline'
                         type='MaterialCommunityIcons'
                         color='lightgray'
                         size={30}
                         />
                         </Pressable>
                         ),
                         })}
                         >
                         {props => <PreferencesScreen {...props} extraData={{user: user}}/>}
                         </Stack.Screen>
                           <Stack.Screen
                           name="View"
                           component={ViewScreen}
                           options={{
                           title: '',
                           }}
                           />
                             <Stack.Screen
                              name="ViewCatalog"
                              options={{
                               title: 'Catalog',
                               presentation: 'transparentModal',
                              }}
                              >
                              {props => <ViewCatalogScreen {...props} extraData={{productLines: account.product_lines}} />}
                              </Stack.Screen>
                             <Stack.Screen
                              name="Notifications"
                              options={{
                               title: 'Notifications',
                              }}
                              >
                              {props => <NotificationsScreen {...props} extraData={{user: user, productLines: account.product_lines}} />}
                              </Stack.Screen>
                           <Stack.Screen
                            name="Tutorial"
                            options={{
                            headerShown: false,
                            }}
                            component={TutorialScreen}/>
                            </>
                            ) : (
                              <>
                              {tutorialEnabled && (
                             <Stack.Screen
                              name="Tutorial"
                              options={{
                              headerShown: false,
                              }}
                              component={TutorialScreen}/>
                              )}
                              <Stack.Screen
                               name="Login"
                               options={({ navigation }) => ({
                                title: 'Welcome',
                              //  headerTitle: () => (
                              //  <Image
                               // style={{resizeMode: 'contain', height: 30, width: 50, alignSelf: 'center'}}
                              //  source={require('./assets/InfernoIconFlame.png')}
                              //  />
                             //   ),
                                headerRight: () => (
                                <Pressable
                                style={{ position: 'absolute', right: 15 }}
                                onPress={() => {
                                navigation.navigate('About')}}>
                                <Icon
                                name='help-outline'
                                type='MaterialCommunityIcons'
                                color='lightgray'
                                size={30}
                                />
                                </Pressable>
                                ),
                               })}
                               >
                               {props => <LoginScreen {...props}/>}
                               </Stack.Screen>

                              <Stack.Screen
                               name="Registration"
                               options={({ navigation }) => ({
                               title: 'Register',
                               headerRight: () => (
                               <Pressable
                               style={{ position: 'absolute', right: 15 }}
                               onPress={() => {
                               navigation.navigate('About')}}>
                               <Icon
                               name='help-outline'
                               type='MaterialCommunityIcons'
                               color='lightgray'
                               size={30}
                               />
                               </Pressable>
                               ),
                               })}
                               >
                               {props => <RegistrationScreen {...props}/>}
                               </Stack.Screen>

                              <Stack.Screen
                               name="Forgot Password"
                               options={{
                               title: 'Forgot Password',
                               }}
                               >
                               {props => <ForgotPasswordScreen {...props}/>}
                               </Stack.Screen>
              </>
              )}
              <Stack.Screen
               name="About"
               component={AboutScreen}
               options={{
               title: 'About',
               }}/>
               <Stack.Screen
                name="Legal"
                component={LegalScreen}
                options={{
                title: 'Legal',
               }}/>
          </Stack.Navigator>
        </NavigationContainer>
  )


/*
//Background Fetch
async function registerBackgroundFetchAsync() {
  return BackgroundFetch.registerTaskAsync(BACKGROUND_FETCH_TASK, {
    minimumInterval: 60 * 11, // 11 minutes
    stopOnTerminate: false, // android only,
    startOnBoot: true, // android only
  });
};
*/

/*
//Background Notifications
async function registerBackgroundNotificationsAsync() {
return Notifications.registerTaskAsync(BACKGROUND_NOTIFICATION_TASK);
};
*/

/*
//Firebase Cloud Messaging
//Request User Permission for iOS Devices.
async function requestUserPermission() {
const authStatus = await Messaging.requestPermission();
const enabled =
authStatus === Messaging.AuthorizationStatus.AUTHORIZED ||
authStatus === Messaging.AuthorizationStatus.PROVISIONAL;

if (enabled) {
console.log('Authorization status: ', authStatus);
}
};*/

/*
//THIS IS A DEVELOPMENT FEATURE! REMOVE PRIOR TO PRODUCTION RELEASE!
async function getMessagingToken2() {
const token = await Messaging.getToken({FCM_WEB_MESSAGING_KEY});
console.log(`FCM Token: ${token}`);
setFCMToken(token);
return usersRef.doc(auth().currentUser.uid).update({fcmTokens: firebase.firestore.FieldValue.arrayUnion(token)}).catch((e) => {console.error(`Error uploading FCM Token: ${e}`)});
}


*/



/*function getMessagingToken() {
Messaging.getToken({FCM_WEB_MESSAGING_KEY}).then((currentToken) => {
if (currentToken) {
console.log(`FCM Token: ${currentToken}`);
//upload it to server
setFCMToken(currentToken);
return usersRef.doc(auth.currentUser.uid).update({fcmTokens: firebase.firestore.FieldValue.arrayUnion(currentToken)}).catch((e) => {console.error(`Error uploading FCM Token: ${e}`)});
}
else {
console.warn(`No token found, re-prompt user to grant permission?`);
}
}).catch((e) => {
console.error(`An error occurred while fetching FCM token: ${e}`);
});
}*/


/*function requestPermission() {
console.log(`Requesting Permission...`);
Notification.requestPermission().then((permission) => {
if (permission === 'granted') {
console.log(`Notification Permission Granted!`);
getMessagingToken();
}
})
}*/

}

